import React, {useCallback, useEffect, useState} from "react";
import styled from "styled-components";
import Button from "../Shared/Button";
import Table from "../Shared/Table";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import useLocalizePhrase from "../../utils/useLocalizePhrase";
import {
    getIsEditPlanInfoMode,
    getOtherRetirementPlans,
    getSelectedPlan,
    getShowOldRetirementplans
} from "../../redux/profile/selectors";
import {showOrHideOtherRetirementPlans} from "../../redux/profile/slice";

const StyledContainer = styled.div`
  margin-top: 24px;
  padding: 32px 40px;
  background-color: #fff;
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const StyledHeader = styled.div`
  border-bottom: 1px solid #bec3c8;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  padding-bottom: 7px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledButtonContainer = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
`;

const StyledContent = styled.div`
  margin: 24px 0;
  font-size: 18px;
  @media (max-width: 768px) {
    margin: 24px 0 16px;
    font-size: 16px;
  }
`;


export const OtherRetirementPlans = () => {
    const dispatch = UseAppDispatch();
    const showOldRetirementplans = UseAppSelector(getShowOldRetirementplans);
    const retirementPlans = UseAppSelector(getOtherRetirementPlans);
    const [tableColumnData,setTableColumnData] = useState([]);
    const headerNames = ["PLAN", "STATUS"];
    const buttonTitle = showOldRetirementplans?"Hide":"Show";
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const otherRetirementPlansTitle = useLocalizePhrase('Other Retirement Plans');
    const lookingForOldRetirementPlansTitle = useLocalizePhrase('Looking for old retirement plans? Show or hide plans that have had a $0 balance for 3+ years');

    useEffect(()=>{
        const status = showOldRetirementplans? "Active": "Hidden";
        let tempArr = retirementPlans.map((ele,i)=>{
            let arr =[];
            arr.push({name:"plan",value:ele.planName})
            arr.push({name:"status",value:status})
            return arr;
        })
        setTableColumnData(tempArr);
    },[retirementPlans,showOldRetirementplans])

    const handleShowOrHide = ()=>{
        const oldPlans = showOldRetirementplans? true : false;
        const savePreferences = {
            "planNumber": planNumber,
            "preferenceType": "oldPlnSup",
            "oldPlans": oldPlans
        }
        dispatchHideOrShow(savePreferences)
    }

    const dispatchHideOrShow = useCallback((savePreferences) => {
        dispatch(showOrHideOtherRetirementPlans({savePreferences}));
    }, [dispatch]);

    return (
        <StyledContainer>
            <StyledHeader>
              {otherRetirementPlansTitle} 
            </StyledHeader>
            <StyledContent>
              {lookingForOldRetirementPlansTitle}.
            </StyledContent>
            <Table headerNames={headerNames} tableColumnData={tableColumnData} borderless={true} />
            <StyledButtonContainer>
                <Button buttonTitle={buttonTitle} onBeaconClick={handleShowOrHide}/>
            </StyledButtonContainer>
        </StyledContainer>
    )
}
